import React, { useState } from "react";
import "./DeprecatedNotice.scss";
const NEW_PORTFOLIO_URL = "https://pranavelric.vercel.app/";

export default function DeprecatedNotice() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="deprecated-notice">
      <div className="deprecated-notice-content">
        <div className="deprecated-notice-text">
          <span className="deprecated-notice-label">
            Portfolio update
          </span>

          <h3>This portfolio is deprecated</h3>

          <p>
            This is an older version of my portfolio. My latest work,
            experience, and projects are now available on my new portfolio.
          </p>

          <a
            href={NEW_PORTFOLIO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="deprecated-notice-link"
          >
            Visit the new portfolio
            <span>↗</span>
          </a>
        </div>

        <button
          type="button"
          onClick={() => setVisible(false)}
          className="deprecated-notice-close"
          aria-label="Dismiss notification"
        >
          ×
        </button>
      </div>
    </div>
  );
}